import React, { useState } from 'react';
import { horses } from '../mock';

const Horses = () => {
  const [active, setActive] = useState(0);

  return (
    <section id="hastarna" className="py-24 md:py-36 bg-[#faf7f2]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl mb-16 md:mb-20 reveal">
          <p className="text-[#8a8572] text-xs uppercase tracking-[0.4em] mb-5">— Hästarna</p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-[#2f3d30] leading-[1.05] mb-6">
            Möt familjen.
          </h2>
          <p className="text-[#4a4a45] font-light leading-relaxed">
            Varje häst i vårt stall har sin egen personlighet, styrka och berättelse. Tillsammans tar de dig säkert och tryggt genom ljungdalsfjällen.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {horses.map((h, i) => (
            <article
              key={h.name}
              className="reveal group cursor-pointer"
              style={{ transitionDelay: `${i * 70}ms` }}
              onMouseEnter={() => setActive(i)}
            >
              <div className="img-zoom aspect-[3/4] overflow-hidden mb-5 relative">
                <img
                  src={h.image}
                  alt={h.name}
                  className="w-full h-full object-cover"
                  style={
                    h.focus
                      ? {
                          transform: `scale(${h.focus.scale})`,
                          objectPosition: h.focus.position,
                          transformOrigin: h.focus.position,
                        }
                      : undefined
                  }
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-500">
                  <p className="text-[#f6efe2] text-xs uppercase tracking-[0.2em]">
                    Född {h.born}
                  </p>
                </div>
              </div>
              <h3 className="font-display text-2xl text-[#2f3d30] mb-1">{h.name}</h3>
              <p className="text-[12px] uppercase tracking-[0.22em] text-[#8a8572]">
                {h.type}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Horses;
